import Types from "./Types";
/* eslint-disable camelcase */

/* Accept transfer */
const postOutbound = (transfer: Object, params: string) => {
  return {
    type: Types.POST_OUTBOUND,
    transfer,
    params
  };
};

const postOutboundSuccess = (transfer: Object, params: string) => {
  return {
    type: Types.POST_OUTBOUND_SUCCESS,
    transfer,
    params
  };
};

const postOutboundFailure = (error: Object) => {
  return {
    type: Types.POST_OUTBOUND_FAILURE,
    error
  };
};

/************************************************
Get Transfers details
*************************************************/

const getTransfers = (query, fromnoon, fbn) => {
  return { type: Types.GET_TRANSFERS, query, fromnoon, fbn };
};

const getTransfersSuccess = transfers => ({
  type: Types.GET_TRANSFERS_SUCCESS,
  transfers
});

const getTransfersFailure = error => ({
  type: Types.GET_TRANSFERS_FAILURE,
  error
});

/************************************************
Get Transfers details
*************************************************/

const getAsn = (query, print, rtv) => {
  return { type: Types.GET_ASN, query, print, rtv };
};

const getAsnSuccess = asn => ({
  type: Types.GET_ASN_SUCCESS,
  asn
});

const getAsnFailure = error => ({
  type: Types.GET_ASN_FAILURE,
  error
});

/************************************************
Get count
*************************************************/

const getTransfersCount = (query, rtv) => {
  return { type: Types.GET_TRANSFERS_COUNT, query, rtv };
};

const getTransfersCountSuccess = transfersCount => {
  return {
    type: Types.GET_TRANSFERS_COUNT_SUCCESS,
    transfersCount
  };
};

const getTransfersCountFailure = error => ({
  type: Types.GET_TRANSFERS_COUNT_FAILURE,
  error
});
/************************************************
getFbnTransfersCount
*************************************************/

const getFbnTransfersCount = query => {
  return { type: Types.GET_FBN_TRANSFERS_COUNT, query };
};

const getFbnTransfersCountSuccess = transfersCount => {
  return {
    type: Types.GET_FBN_TRANSFERS_COUNT_SUCCESS,
    transfersCount
  };
};

const getFbnTransfersCountFailure = error => ({
  type: Types.GET_FBN_TRANSFERS_COUNT_FAILURE,
  error
});

/************************************************
Close
*************************************************/

const closeAsn = warehouse => {
  return { type: Types.CLOSE_ASN, warehouse };
};

const closeAsnSuccess = close => {
  return {
    type: Types.CLOSE_ASN_SUCCESS,
    close
  };
};

const closeAsnFailure = error => ({
  type: Types.CLOSE_ASN_FAILURE,
  error
});

/************************************************
Close
*************************************************/

const openFbnAsn = whObj => {
  return {
    type: Types.OPEN_FBN_ASN,
    whObj
  };
};

const openFbnAsnSuccess = initialLines => {
  return {
    type: Types.OPEN_FBN_ASN_SUCCESS,
    initialLines
  };
};

const openFbnAsnFailure = error => ({
  type: Types.OPEN_FBN_ASN_FAILURE,
  error
});

/************************************************
Close
*************************************************/

const importFbnAsn = file => {
  return {
    type: Types.IMPORT_FBN_ASN,
    file
  };
};

const importFbnAsnSuccess = success => {
  return {
    type: Types.IMPORT_FBN_ASN_SUCCESS,
    success
  };
};

const importFbnAsnFailure = error => ({
  type: Types.IMPORT_FBN_ASN_FAILURE,
  error
});

/************************************************
scheduleAsn
*************************************************/

const scheduleAsn = obj => {
  return {
    type: Types.SCHEDULE_ASN,
    obj
  };
};

const scheduleAsnSuccess = success => {
  return {
    type: Types.SCHEDULE_ASN_SUCCESS,
    success
  };
};

const scheduleAsnFailure = error => ({
  type: Types.SCHEDULE_ASN_FAILURE,
  error
});

/************************************************
Close
*************************************************/

const getInitialLines = (query, typeText) => {
  return {
    type: Types.GET_INITIAL_LINES,
    query,
    typeText
  };
};

const getInitialLinesSuccess = initialLines => {
  return {
    type: Types.GET_INITIAL_LINES_SUCCESS,
    initialLines
  };
};

const getInitialLinesFailure = error => ({
  type: Types.GET_INITIAL_LINES_FAILURE,
  error
});

/************************************************
Close
*************************************************/

const getProcessedLines = (query, print, scheduled) => {
  return {
    type: Types.GET_PROCESSED_LINES,
    query,
    print,
    scheduled
  };
};

const getProcessedLinesSuccess = lines => {
  return {
    type: Types.GET_PROCESSED_LINES_SUCCESS,
    lines
  };
};

const getProcessedLinesFailure = error => ({
  type: Types.GET_PROCESSED_LINES_FAILURE,
  error
});

/************************************************
Close
*************************************************/

const getAsnBatches = query => {
  return {
    type: Types.GET_ASN_BATCHES,
    query
  };
};

const getAsnBatchesSuccess = batches => {
  return {
    type: Types.GET_ASN_BATCHES_SUCCESS,
    batches
  };
};

const getAsnBatchesFailure = error => ({
  type: Types.GET_ASN_BATCHES_FAILURE,
  error
});

/************************************************
Export ELIGIBLE
*************************************************/

const exportEligibleOffers = () => {
  return {
    type: Types.EXPORT_ELIGIBLE_OFFERS
  };
};

const exportEligibleOffersSuccess = () => {
  return {
    type: Types.EXPORT_ELIGIBLE_OFFERS_SUCCESS
  };
};

const exportEligibleOffersFailure = error => ({
  type: Types.EXPORT_ELIGIBLE_OFFERS_FAILURE,
  error
});

/************************************************
retrieve slots
*************************************************/

const retrieveSlots = obj => {
  return {
    type: Types.RETRIEVE_SLOTS,
    obj
  };
};

const retrieveSlotsSuccess = slots => {
  return {
    type: Types.RETRIEVE_SLOTS_SUCCESS,
    slots
  };
};

const retrieveSlotsFailure = error => ({
  type: Types.RETRIEVE_SLOTS_FAILURE,
  error
});

/************************************************
GET STATUS
*************************************************/

const getStatus = () => {
  return {
    type: Types.GET_STATUS
  };
};

const getStatusSuccess = (status) => {
  return {
    type: Types.GET_STATUS_SUCCESS,
    status
  };
};

const getStatusFailure = error => ({
  type: Types.GET_STATUS_FAILURE,
  error
});

/************************************************
GET RTV STATUS
*************************************************/

const getRtvStatuses = () => {
  return {
    type: Types.GET_RTV_STATUS
  };
};

const getRtvStatusesSuccess = (rtvStatus) => {
  return {
    type: Types.GET_RTV_STATUS_SUCCESS,
    rtvStatus
  };
};

const getRtvStatusesFailure = error => ({
  type: Types.GET_RTV_STATUS_FAILURE,
  error
});

export {
  postOutbound,
  postOutboundSuccess,
  postOutboundFailure,
  getTransfers,
  getTransfersSuccess,
  getTransfersFailure,
  getAsn,
  getAsnSuccess,
  getAsnFailure,
  getTransfersCount,
  getTransfersCountSuccess,
  getTransfersCountFailure,
  closeAsn,
  closeAsnSuccess,
  closeAsnFailure,
  openFbnAsn,
  openFbnAsnSuccess,
  openFbnAsnFailure,
  getInitialLines,
  getInitialLinesSuccess,
  getInitialLinesFailure,
  importFbnAsn,
  importFbnAsnSuccess,
  importFbnAsnFailure,
  scheduleAsn,
  scheduleAsnSuccess,
  scheduleAsnFailure,
  exportEligibleOffers,
  exportEligibleOffersSuccess,
  exportEligibleOffersFailure,
  getProcessedLines,
  getProcessedLinesSuccess,
  getProcessedLinesFailure,
  getAsnBatches,
  getAsnBatchesSuccess,
  getAsnBatchesFailure,
  getFbnTransfersCount,
  getFbnTransfersCountSuccess,
  getFbnTransfersCountFailure,
  retrieveSlots,
  retrieveSlotsSuccess,
  retrieveSlotsFailure,
  getStatus,
  getStatusSuccess,
  getStatusFailure,
  getRtvStatuses,
  getRtvStatusesSuccess,
  getRtvStatusesFailure
};



// WEBPACK FOOTER //
// ./src/actions/TransferActions.js